import React from 'react';

export const otherPaymentOptionsTitle =
  'Payment options for disability compensation';

export const OtherPaymentOptionsDescription = () => (
  <>
    <p>
      You don’t need a bank account to file a disability compensation claim. And
      not having a bank account won’t affect our decision about your claim.
    </p>
    <p>If we do approve your claim, you have 2 options to get payments.</p>
    <p>
      <strong>Note:</strong> You can wait until after you submit your claim to
      decide on a payment option.
    </p>
    <h4>Option 1: Open a bank account</h4>
    <p>
      The Veterans Benefits Banking Program (VBBP) can help you open a bank
      account. This program provides a list of Veteran-friendly banks and credit
      unions. They can help you set up or qualify for an account.
    </p>
    <p>
      To get started, call a participating bank or credit union on VBBP’s
      website. Make sure you mention the Veterans Benefits Banking Program.
    </p>
    <va-link
      external
      href="https://veteransbenefitsbanking.org/find-bank-credit-union/"
      text="Find a bank on VBBP’s website"
    />
    <h4>Option 2: Contact the Department of Treasury</h4>
    <p>
      If you don’t want to set up an account, you must call the Department of
      Treasury at <va-telephone contact="8882242950" />.
    </p>
    <p>
      They’ll give you information about other options, such as the Direct
      Express® prepaid debit card.
    </p>
  </>
);
